import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Advanced Tax-Strategy Consulting",
  description: "Proactive liability minimization and tax-efficient structuring tailored for high-net-worth portfolios and complex income streams.",
  step: "01"
}, {
  title: "Private Life Insurance Solutions",
  description: "Strategic liquidity planning and asset protection utilizing premium insurance instruments to secure generational wealth.",
  step: "02"
}, {
  title: "Comprehensive Financial Planning",
  description: "Holistic wealth roadmaps integrating investment management, estate goals, and tax objectives into a unified strategy.",
  step: "03"
}, {
  title: "Real Estate Investment Advisory",
  description: "Expert market analysis and portfolio structuring designed to optimize passive income and capital appreciation in the Carolinas.",
  step: "04"
}, {
  title: "Small Business Wealth Management",
  description: "Capital efficiency strategies, succession planning, and executive benefit structures for business owners and entrepreneurs.",
  step: "05"
}, {
  title: "Entity Structuring for Investors",
  description: "Optimized legal framework guidance to safeguard assets, limit liability, and enhance operational flexibility for investors.",
  step: "06"
}, {
  title: "Philanthropic Advising",
  description: "Strategic charitable giving frameworks designed to maximize social impact while optimizing tax advantages for multi-generational legacies.",
  step: "07"
}];
export default function StrategicServiceGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="strategic-service-grid" ref={ref} className="dark bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-50" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-50" />

      <div className="max-w-7xl mx-auto">
        <div className={`mb-16 max-w-3xl transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-6">
            Wealth Architecture &<br />
            <span className="text-primary italic">Strategic Precision</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl leading-relaxed">
            Our firm delivers a sophisticated suite of financial services designed to address the complex needs of wealth building and asset protection and business owners throughout North and South Carolina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Card className="group relative h-full bg-white text-slate-950 border border-slate-200 hover:border-primary transition-colors duration-300 rounded-sm overflow-hidden shadow-none">
                <CardHeader className="pb-4 relative z-10">
                  <div className="flex justify-between items-start mb-4">
                    <span className="font-mono text-primary text-lg font-medium tracking-wider">
                      {service.step}
                    </span>
                    <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-primary transition-colors duration-300" />
                  </div>
                  <CardTitle className="font-serif text-2xl text-slate-900 group-hover:text-primary transition-colors duration-300 leading-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <CardDescription className="text-slate-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                
                {}
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/[0.02] transition-colors duration-300 pointer-events-none" />
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}